exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".RefreshActionForm-module__container__2osst {\r\n\twidth: 300px;\r\n\tpadding: calc(var(--design-unit) * 2px);\r\n}\r\n", "",{"version":3,"sources":["C:\\Users\\andrew\\IdeaProjects\\cmu\\moni2\\src\\components\\view\\RefreshActionForm.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,uCAAuC;AACxC","file":"RefreshActionForm.module.css","sourcesContent":[".container {\r\n\twidth: 300px;\r\n\tpadding: calc(var(--design-unit) * 2px);\r\n}\r\n"]}]);

// Exports
exports.locals = {
	"container": "RefreshActionForm-module__container__2osst"
};